import { jsx as _jsx } from "react/jsx-runtime";
import { isMessagePartArtifact, isMessagePartAttachments, isMessagePartLCATProgress, isMessagePartReasoning, isMessagePartText, isMessagePartTool } from '../types';
import { ArtifactPart } from './ArtifactPart';
import { AttachmentsPart } from './AttachmentsPart';
import { LCATProgressPart } from './LCATProgressPart';
import { ReasoningPart } from './ReasoningPart';
import { TextPart } from './TextPart';
import { ToolPart } from './ToolPart';
/**
 * Renders different types of message parts based on type
 * NOTE: Not memoized - this is a lightweight router and parts change frequently during streaming
 */ export function MessagePartRenderer({ part, messageId, index, chatId, variant = 'default' }) {
    // Handle text parts
    if (isMessagePartText(part)) {
        return /*#__PURE__*/ _jsx(TextPart, {
            part: part,
            messageId: messageId,
            index: index,
            variant: variant
        });
    }
    // Artifact preview (rendered inside the message)
    if (isMessagePartArtifact(part)) {
        return /*#__PURE__*/ _jsx(ArtifactPart, {
            part: part,
            messageId: messageId,
            index: index,
            chatId: chatId,
            variant: variant
        });
    }
    // Handle attachments
    if (isMessagePartAttachments(part)) {
        return /*#__PURE__*/ _jsx(AttachmentsPart, {
            part: part,
            messageId: messageId,
            index: index
        });
    }
    // Handle tool calls (basic rendering)
    if (isMessagePartTool(part)) {
        return /*#__PURE__*/ _jsx(ToolPart, {
            part: part,
            messageId: messageId,
            index: index,
            variant: variant
        });
    }
    // Handle reasoning
    if (isMessagePartReasoning(part)) {
        return /*#__PURE__*/ _jsx(ReasoningPart, {
            part: part,
            messageId: messageId,
            index: index
        });
    }
    // LCAT progress tracker
    if (isMessagePartLCATProgress(part)) {
        return /*#__PURE__*/ _jsx(LCATProgressPart, {
            part: part,
            messageId: messageId,
            index: index
        });
    }
    return null;
}
